var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"id":"go-to-top-button"},on:{"click":_vm.onGoToTopButton}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"water"}},[_c('img',{staticClass:"pc-image",attrs:{"alt":"","src":require("../../assets/images/views/top-view/go-to-top-button.png")}})])
}]

export { render, staticRenderFns }